import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.75 1H12v6.5H8.75a3.25 3.25 0 1 1 0-6.5M13 8V1h3.5a3.5 3.5 0 1 1 0 7zm6.5 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M12 8.75H8.75a3.25 3.25 0 0 0 0 6.5H12zm0 7.75v3.25a3.25 3.25 0 1 1-3.25-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSoftwareDesignFigma = { render };
export {
  brandSoftwareDesignFigma as default,
  render
};
//# sourceMappingURL=brand-software-design-figma.svg.js.map
